// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/house.js';

import { paths } from '../generated/house';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('house', Original, paths);
